import {
  viandas2Get,
  viandas2Post,
  viandas2Put,
  viandas2Delete,
} from "../../common/service/viandas2Client";

export const getDisponibles = (desde, hasta) =>
  viandas2Get("/disponibles", { desde, hasta });

export const getMisPedidos = (desde, hasta) =>
  viandas2Get("/mis-pedidos", { desde, hasta });

export const crearPedido = (id_menu, fecha) =>
  viandas2Post("/pedidos", { id_menu, fecha });

export const actualizarPedido = (id, id_menu) =>
  viandas2Put(`/pedidos/${id}`, { id_menu });

export const cancelarPedido = (id) => viandas2Delete(`/pedidos/${id}`);
